import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import closeIcon from "../../../../assets/closeModel.png";
import {
  addOperationStaffAction,
  getAllSkillAction,
  getSingleOperationStaffAction,
  initialAssignWorkerState,
} from "../../../../store/reducers/assignWorkerSlice";
import { useDispatch } from "react-redux";
import Validation from "../../../../utils/Validation";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import FormField from "../../../../components/common/FormField";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { STAFF_FORM_FIELDS } from "./staffAllFields";
import { useSelector } from "react-redux";
import ResetFormAlert from "./ResetFormAlert";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";

interface ManageStaffProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedStaff: any; // Adjust type as per your requirement
  action?: any;
  setSelectedStaff?: any;
}

const ManageStaff: React.FC<ManageStaffProps> = ({
  open,
  onHide,
  title,
  selectedStaff,
  action,
  setSelectedStaff,
}) => {
  const classes = useStyles();
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [staffDetails, setStaffDetails] = useState<any>(
    initialAssignWorkerState,
  );
  const { skills, singleOperationStaff } = useSelector(
    (state: any) => state.assignWorker,
  );
  const { users } = useSelector((state: any) => state.subUser);
  const { userProfile } = useSelector((state: any) => state.user);
  const [resetAlert, setResetAlert] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [alertModel, setAlertModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [countryCodes, setCountryCodes] = useState<{ [key: string]: string }>({
    phone: "+44",
    emergencyPhone: "+44",
  });
  const [alerModeShow, setAlertModelShow] = useState(false);
  const dispatch = useDispatch();
  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    name: staffDetails?.name,
    aka_name: staffDetails?.aka_name,
    staff_email: staffDetails?.staff_email,
    phone: staffDetails?.phone,
    emergency_contact_number: staffDetails?.emergency_contact_number,
  });

  useEffect(() => {
    if (open) {
      dispatch(getAllSkillAction());
      setStaffDetails((prev: any) => ({
        ...prev,
        checked_by: userProfile?.name || "", // or currentUser?.id
      }));
    }
  }, [dispatch, open]);

  useEffect(() => {
    if (selectedStaff && open) {
      dispatch(getSingleOperationStaffAction(selectedStaff));
    }
  }, [selectedStaff, open]);

  useEffect(() => {
    if (
      singleOperationStaff &&
      Object.keys(singleOperationStaff).length > 0 &&
      action === "edit"
    ) {
      const extractPhoneParts = (phone: string) => {
        if (!phone || !phone.startsWith("+")) {
          return { code: "+44", number: phone || "" };
        }
        const match = phone?.match(/^\+91|\+44/);
        if (match) {
          return { code: match[0], number: phone.replace(match[0], "") };
        }
        return { code: "+44", number: phone };
      };

      let updatedDetails: any = {
        ...singleOperationStaff,
        skills:
          singleOperationStaff.skills?.map((s: any) => ({
            id: s.id,
            name: s.name, // ✅ match FormMultiChipCheckbox
          })) || [],
      };

      // Phone
      if (singleOperationStaff?.phone) {
        const { code, number } = extractPhoneParts(singleOperationStaff.phone);
        updatedDetails.phone = number;
        setCountryCodes((prev) => ({ ...prev, phone: code }));
      }

      // Emergency Phone
      if (singleOperationStaff?.emergency_contact_number) {
        const { code, number } = extractPhoneParts(
          singleOperationStaff.emergency_contact_number,
        );
        updatedDetails.emergency_contact_number = number;
        setCountryCodes((prev) => ({ ...prev, emergencyPhone: code }));
      }

      setStaffDetails(updatedDetails); // ✅ single update
    }
  }, [singleOperationStaff, action]);

  const handleCountryCodeChange = (field: string, value: string) => {
    setCountryCodes((prev) => ({ ...prev, [field]: value }));
    resetValidator(field);
  };

  const handleInputChange = (field: string, value: any) => {
    setStaffDetails((prevState: any) => {
      if (field === "skills") {
        // Save array of objects directly
        return { ...prevState, skills: value };
      }
      return { ...prevState, [field]: value };
    });
    setIsChanged(true);
    resetValidator(field);
  };

  // Extract vehicle types from the vehicleTypes array
  const skillsListData = skills.map((item: any) => ({
    id: item?.id,
    label: item?.title,
  }));

  const userListData = users.map((item: any) => ({
    id: item?.name,
    label: item?.name,
  }));

  const updatedFields = STAFF_FORM_FIELDS.map((field) => {
    if (field.id === "skills") {
      return { ...field, options: skillsListData, type: "multiSelectChip" };
    } else if (field.id === "checked_by") {
      return { ...field, options: userListData, type: "select" };
    }
    return field;
  });

  const onBlurAction = (event: any) => {
    checkValidator(event.target.id);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  const hideHandler = () => {
    if (isChanged) {
      setAlertModel(true);
      setAlertMessage(
        "Changes have been made. Are you sure you abandon the changes?",
      );
    } else {
      onHide();
      setStaffDetails(initialAssignWorkerState);
      setIsChanged(false);
    }
    // setSelectedStaff(null);
    resetAllValidator();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  useEffect(() => {
    if (isActionCalled) {
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        const finalPayload = {
          ...staffDetails,
          phone: staffDetails.phone
            ? `${countryCodes.phone}${staffDetails.phone}`
            : "",
          emergency_contact_number: staffDetails.emergency_contact_number
            ? `${countryCodes.emergencyPhone}${staffDetails.emergency_contact_number}`
            : "",
        };
        if (
          action === "edit" &&
          selectedStaff &&
          Object.keys(selectedStaff).length > 0
        ) {
          dispatch(
            addOperationStaffAction({
              id: selectedStaff,
              ...finalPayload,
            }),
          );
        } else {
          // remove id from payload
          const { id, ...rest } = finalPayload;
          dispatch(addOperationStaffAction(rest));
        }
        setIsActionCalled(false);
      } else {
        console.log("error in form", error);
      }
      setIsActionCalled(false);
      setIsChanged(false);
    }
  }, [isActionCalled]);

  const handleClear = () => {
    if (singleOperationStaff?.id && action === "edit") {
      setStaffDetails({ ...singleOperationStaff });
    } else {
      setStaffDetails(initialAssignWorkerState);
    }
    // setSelectedStaff(null);
    setIsChanged(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    resetAllValidator();
    setIsClickReset(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const resetFormData = () => {
    if (singleOperationStaff?.id) {
      setStaffDetails(singleOperationStaff);
    } else {
      setStaffDetails(initialAssignWorkerState);
    }
    setIsChanged(false);
    setResetAlert(false);
    setAlertModel(false);
  };

  const closeAlertModel = () => {
    setAlertModel(false);
    setResetAlert(false);
    onHide();
  };

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"md"}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              // style={{ right: 40 }}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            {/* <CustomButton
                      style={{ padding: "10px 30px", height: "36px" }}
                      title="Save"
                      onClick={handleSubmit}
                    />
                    <CustomButton
                      style={{ padding: "10px 30px", height: "36px" }}
                      variant="outlined"
                      title="Cancel"
                      onClick={closeModel}
                    /> */}
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText
            sx={{
              background: "#E5F4F1",
              padding: "10px 10px 10px 0px",
              border: "1px solid #CFCFCF",
              borderRadius: "5px",
            }}
          >
            <>
              <Notification />
              <Grid container spacing={1}>
                {updatedFields?.map((field, i) => {
                  let dynamicField = { ...field };
                  return (
                    <>
                      <FormField
                        key={field.id}
                        onPaste={(e: any) =>
                          field?.id === "name" ||
                          field?.id === "notes" ||
                          field?.id === "staff_email"
                            ? ""
                            : e.preventDefault()
                        }
                        onKeyDown={(event: any) => {
                          if (event.key === "Delete") {
                            return;
                          }
                          if (
                            [8, 9, 37, 38, 39, 40, 18, 17].includes(
                              event.keyCode,
                            ) ||
                            event.ctrlKey
                          )
                            return;
                          if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                        {...{
                          ...dynamicField,
                          value: staffDetails
                            ? staffDetails[dynamicField.id]
                            : dynamicField.type === "multiSelectChip"
                              ? [] // default array for multi-select
                              : "",
                          inSingleGridForm: true,
                          minDate:
                            field.id === "movingOnDate"
                              ? new Date()
                              : undefined,
                          // maxDate:
                          //   field.id === "followUpDate"
                          //     ? newLeadLocal?.movingOnDate &&
                          //       dayjs(newLeadLocal.movingOnDate)
                          //         .toDate()
                          //     : undefined,
                          variant: "outlined",
                          // ✅ Pass the current country code to FormField
                          countryCode:
                            field.type === "contact"
                              ? countryCodes[field.id]
                              : undefined,
                          // ✅ make it dynamic instead of hardcoded
                          onCountryCodeChange:
                            field.type === "contact"
                              ? (val: string) =>
                                  handleCountryCodeChange(field.id, val)
                              : undefined,
                          onChange: (value: any) => {
                            if (
                              Array.isArray(value) &&
                              field.type === "multiSelectChip"
                            ) {
                              // For FormMultiChipCheckbox (multiSelectChip)
                              handleInputChange(field.id, value);
                            } else {
                              // For normal inputs (event)
                              handleInputChange(
                                field.id,
                                value?.target?.value ?? value,
                              );
                            }
                          },
                          onBlur: onBlurAction,
                          isNonMarginTop: true,
                          multiline: field.id === "notes",
                          GridFieldStyle: {
                            paddingLeft:
                              field.type === "daterangebothvalue" ||
                              field.type === "date"
                                ? "8px !important"
                                : "auto",
                          },
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx:
                              field.type === "text" || field.type === "password"
                                ? { height: "36px" }
                                : { padding: "10px 4px", height: "36px" },
                          },
                          error: error && error[field.id],
                          // helperText: error && error[field.id],
                        }}
                      />
                    </>
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}

      {alertMessage && (
        <AlertPopup
          open={alertModel}
          // onClose={() => setAlertModel(false)}
          title="Alert"
          content={alertMessage}
          submitHandler={() => {
            resetAlert ? resetFormData() : closeAlertModel();
          }}
          onHide={() => setAlertModel(false)}
          isError={false}
        />
      )}
    </>
  );
};

export default ManageStaff;
